/**
 * ErrorState - Error state component for knowledge base
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ Mobile: Safe area handling
 * - ✅ Consistent design language
 */

import React from 'react';
import { Link } from 'react-router-dom';
import LandingHeader from '../../LandingHeader';
import Footer from '../../../../components/Footer';
import { isIOSDevice } from '../../../utils/deviceDetection';
import { BACKGROUND_COLORS, DEFAULT_COLOR } from '../constants';

export const ErrorState: React.FC = () => {
  const isIOS = isIOSDevice();

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: BACKGROUND_COLORS.error }}>
      <LandingHeader />
      <div 
        className="flex-grow container mx-auto px-4 py-8 max-w-4xl text-center"
        style={{ 
          marginTop: isIOS ? 'calc(4rem + env(safe-area-inset-top, 0px))' : '4rem'
        }}
      >
        <h1 className="text-3xl font-bold mb-4" style={{ color: DEFAULT_COLOR }}>
          Article Not Found
        </h1>
        <p className="mb-6" style={{ color: '#598D76' }}>
          Sorry, we couldn&apos;t find the article you&apos;re looking for.
        </p>
        <Link 
          to="/knowledge-base" 
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all"
          style={{ 
            backgroundColor: DEFAULT_COLOR,
            color: 'white'
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
          Back to Knowledge Base
        </Link>
      </div>
      <Footer />
    </div>
  );
};